import { Button } from "components/button/Button/Button";
import { StyledDialogHeader } from "./style";
import { useDialogContext } from "../controller/DialogProvider";
import { useDialogOverlayContext } from "../controller/DialogOverlay";

interface DialogHeaderProps {
  children: React.ReactNode;
  isDraggable?: boolean;
}

export const DialogHeader = ({
  children,
  isDraggable = false,
}: DialogHeaderProps) => {
  const { $size, $preventClose } = useDialogOverlayContext();
  const { containerRef, dialogPosition, closeDialog } = useDialogContext();

  const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!dialogPosition.current || !containerRef.current) return;

    e.preventDefault();

    const dialogEl = containerRef.current;

    // 드래그 시작 시점의 마우스 위치 & 기존 translate 값
    const startMouse = { x: e.clientX, y: e.clientY };
    const startPos = {
      x: dialogPosition.current.x ?? 0,
      y: dialogPosition.current.y ?? 0,
    };

    // 화면 경계 계산용: 현재 박스 위치 기준
    const rect = dialogEl.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // translate 기준으로 허용 가능한 범위 (대충 화면 안에서만 보이게)
    const maxRight = vw - rect.right; // 오른쪽으로 더 갈 수 있는 여유
    const maxLeft = rect.left; // 왼쪽 여유
    const maxBottom = vh - rect.bottom; // 아래 여유
    const maxTop = rect.top; // 위 여유

    const onMouseMove = (ev: MouseEvent) => {
      const dx = ev.clientX - startMouse.x;
      const dy = ev.clientY - startMouse.y;

      if (!dialogPosition.current) return;

      let nextX = startPos.x + dx;
      let nextY = startPos.y + dy;

      // 화면 밖으로 나가지 않게 clamp
      nextX = Math.min(nextX, maxRight + startPos.x);
      nextX = Math.max(nextX, startPos.x - maxLeft);

      nextY = Math.min(nextY, maxBottom + startPos.y);
      nextY = Math.max(nextY, startPos.y - maxTop);

      dialogPosition.current.x = nextX;
      dialogPosition.current.y = nextY;
      dialogEl.style.transform = `translate(${nextX}px, ${nextY}px)`;
    };

    const onMouseUp = () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };

  return (
    <StyledDialogHeader
      $size={$size}
      $isDraggable={isDraggable}
      onMouseDown={isDraggable ? onMouseDown : undefined}
    >
      <p>{children}</p>
      {!$preventClose && (
        <Button
          size={$size === "small" ? "medium" : "large"}
          preIcon="XCloseMd"
          color="strong"
          type="text"
          onClick={closeDialog}
        />
      )}
    </StyledDialogHeader>
  );
};
